import React from "react";

const getChronicRiderLabel = (strings, riderLabels) => strings[riderLabels.chronic.toLowerCase()];
const getChronicRiderLabelDescription = (strings, riderLabels) => strings[`${riderLabels.chronic.toLowerCase()}Description`];

const getMentalRiderLabel = (strings, riderLabels) => strings[riderLabels.mental.toLowerCase()];

const getMaternityRiderLabel = (strings, riderLabels) => strings[riderLabels?.maternity?.toLowerCase() || 'maternity'];

const fillTextWithRiderLabel = (text, riderLabel) => text.replaceAll('$riderLabel', riderLabel.toLowerCase());

const buildRiderDescriptionArray = (details1, amount, details2, riderLabel, isAmountBold) => {
    const amountFormatted = isAmountBold ? <b>{amount}</b> : amount;

    return [details1, amountFormatted, fillTextWithRiderLabel(details2, riderLabel)];
}

const buildRiderDescription = (details1, amount, details2, riderLabel) =>
    buildRiderDescriptionArray(details1, amount, details2, riderLabel, false).join('');

export {
    getChronicRiderLabel,
    getChronicRiderLabelDescription,
    getMentalRiderLabel,
    getMaternityRiderLabel,
    buildRiderDescriptionArray,
    buildRiderDescription,
}